<template>
  <section
    aria-labelledby="shop-the-look-heading"
    :class="[
      brandClasses.shopTheLookWrapper,
      $feature.showFullscreenGridOnPDP ? brandClasses.gridFullWidth : brandClasses.gridPartialWidth,
    ]"
    data-scroll-el="shopTheLook"
  >
    <h2
      id="shop-the-look-heading"
      class="my-4 title-2 "
      :class="brandClasses.shopTheLookHeading"
    >
      {{ $t.shopTheLookHeading }}
    </h2>
    <vf-carousel
      v-if="product"
      class="flex justify-center"
      class-container="flex gap-x-2 md:mx-10 -mx-2"
      class-controls="transform -translate-y-10 -mt-6 !pb-0"
      :loop="gallery.loop"
    >
      <base-button
        v-for="productSet in product.productSets"
        :key="productSet.productSetId"
        class="mb-4 text-center <md:w-full px-1"
        @click="openShopTheLook(productSet)"
      >
        <base-picture
          :alt="productSet.description"
          class="mb-4 block"
          :props-img="{ class: 'mx-a w-72 object-contain' }"
          :src="productSet.images[0]"
        />
        <span
          class="flex items-center title-4 "
          :class="brandClasses.shopTheLookCta"
        >
          {{ productSet.text || $t.shopTheLookTileCta }}
          <vf-icon
            v-if="shopTheLook?.showLinkArrow"
            class="ml-1 c-black i-block"
            dir="right"
            name="arrow"
            size="md"
          />
        </span>
      </base-button>
    </vf-carousel>
  </section>
</template>

<script setup lang="ts">
const { brandClasses, gallery, shopTheLook } = useAppConfig().pages?.pdp || {}
const { openShopTheLook, product } = usePdp()
</script>
